import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const TickIcon = ({tintColor = '#fff', ...props}) => {
  return (
    <Svg
      width={60}
      height={42}
      viewBox="0 0 60 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.644 1.856a3.563 3.563 0 010 5.038l-33.25 33.25a3.563 3.563 0 01-5.038 0l-19-19a3.563 3.563 0 015.038-5.038l16.481 16.48 30.73-30.73a3.563 3.563 0 015.04 0z"
        fill={tintColor}
      />
    </Svg>
  );
};

export default TickIcon;
